import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';

/**
 * A grant type's yearly maximum budget. The whole set for an organisation is read through
 * `organisation_profiles/{id}/grant_yearly_maximums` (see OrganisationProfileApiService); this
 * service handles the per-row create/update.
 */
@Injectable({
  providedIn: 'root'
})
export class GrantYearlyMaximumApiService extends ApiService {
  readonly resourcePath = 'grant_yearly_maximums';

  create(data: object): Observable<any> {
    return this.restCreate<any>(data);
  }

  update(id: string, data: object): Observable<any> {
    return this.restUpdate<any>(id, data);
  }

  delete(id: string): Observable<null> {
    return this.restDelete(id);
  }
}
